// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"62772b83","275":"44adb068","428":"bf82a26c","430":"63426c17","494":"0382bb08","697":"6229dad9","701":"7190f8a9","707":"e52d150d","720":"44526d7b","757":"2531fe75","974":"5aedba18"}[chunkId] + ".chunk.js";
};